const interceptData = [
    //id-format: "Prod|Stage|Test"
    {
        id:"15864|15858|16730|16731|16732|16733|16734|17859|17895|18129|18396|18397|18398|118074|112630|109194",
        intercept_name: "Google",
        intercept_subtitle: "google_intercept_subtitle",
        intercept_title: "google_intercept_title",
        intercept_text1: "google_intercept_text1",
        intercept_text2: "google_intercept_text2",
        intercept_text3: "google_intercept_text3",
        intercept_text4: "google_intercept_text4",
        intercept_text5: "google_intercept_text5",
        intercept_text6: "google_intercept_text6",
        intercept_text7: "google_intercept_text7",
        intercept_text8: "google_intercept_text8",
        intercept_dd_mmm_text: "google_dd_mmm_text",
        is_dd_mmm_text_bold: true,
        intercept_sso_text: "google_sso_text",
        intercept_time: "google_intercept_time",
        intercept_date: "google_intercept_date",
        intercept_on_text: "google_intercept_on_text",
        intercept_link_not_work: "google_link_not_work",
        intercept_note:"learnship_note_google",
        intercept_family_note:"learnship_family_note_google",
        intercept_window_title: "SSO Google Intercept",
        intercept_duration:"REACT_APP_GOOGLE_INTERCEPT",
        intercept_url:"/google",
        support_url:"REACT_APP_GOOGLE_SUPPORT_URL",
        learnship_home_url:"REACT_APP_LEARNSHIP_URL",
        learnship_login_url:"REACT_APP_LOGINURL"
    },
    {
        id:"92824|92825|92826|92844|120597|117739|77274|112628|109413",
        intercept_name: "Nestle",
        intercept_title: "nestle_intercept_title",
        intercept_subtitle: "nestle_intercept_subtitle",
        intercept_text1: "nestle_intercept_text1",
        intercept_text2: "nestle_intercept_text2",
        intercept_text3: "nestle_intercept_text3",
        intercept_text4: "nestle_intercept_text4",
        intercept_text5: "nestle_intercept_text5",
        intercept_text6: "nestle_intercept_text6",
        intercept_text7: "nestle_intercept_text7",
        intercept_text8: "nestle_intercept_text8",
        intercept_dd_mmm_text: "nestle_dd_mmm_text",
        intercept_support_text: "nestle_service_desk",
        intercept_or_text: "nestle_intercept_or_text",
        is_dd_mmm_text_bold: true,
        intercept_sso_text: "nestle_sso_text",
        intercept_time: "nestle_intercept_time",
        intercept_date: "nestle_intercept_date",
        intercept_on_text: "nestle_intercept_on_text",
        intercept_link_not_work: "nestle_link_not_work",
        intercept_note:"learnship_note_nestle",
        intercept_family_note:"learnship_family_note_nestle",
        intercept_window_title: "SSO Nestle Intercept",
        intercept_duration:"REACT_APP_NESTLE_INTERCEPT",
        intercept_url:"/nestle",
        learnship_home_url:"REACT_APP_LEARNSHIP_URL",
        learnship_login_url:"REACT_APP_LOGINURL",
        support_url:"REACT_APP_NESTLE_SUPPORT_URL"
    }
]

export { interceptData };